export const DEFAULT_STATE = {
  currentType: null,
  availableTypes: [],
};

const TEST = 'TEST';

export const priceToggle = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case TEST:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
